// BUILD-042 — Unified employee workspace, My HR (self). "Training & Qualifications"
// destination. The approved reference shows four sub-tabs here (Training / Qualifications /
// Experience & skills / Memberships) — but the real, already-working implementation is two
// cohesive pages (Qualifications: Work Experience/Education/Skills/Languages/Licenses/Company-
// verified/Attachments all together; Memberships: its own page), not four separately-built
// pieces. Splitting QualificationsPage's internals apart to force four sub-tabs would be new,
// risky surgery on already-working interactions for a presentation-only consolidation task —
// the decision's visual contract says sub-tabs "may" be used "where shown," not that every
// section must match the reference's exact sub-tab count. Two sub-tabs (Qualifications /
// Memberships) satisfies "single content section with useful internal sub-tabs; no long stack
// of every form" using the EXACT existing, unchanged components.
import { SubTabs } from './SubTabs';
import { QualificationsPage, MembershipsPage } from '../MyHrQualifications';

type Tab = 'qualifications' | 'memberships';

export function TrainingQualificationsSelfSection({ employeeId, employeeName }: { employeeId: string; employeeName: string }) {
  return (
    <SubTabs<Tab>
      tabs={[
        { key: 'qualifications', label: 'Qualifications' },
        { key: 'memberships', label: 'Memberships' },
      ]}
      initial="qualifications"
    >
      {(active) => (active === 'qualifications'
        ? <QualificationsPage employeeId={employeeId} employeeName={employeeName} />
        : <MembershipsPage employeeId={employeeId} employeeName={employeeName} />
      )}
    </SubTabs>
  );
}
